module.exports = __webpack_public_path__ + "img/Qrespi-Logo.9ecbd888.png";